/**
 * <terms-agreement>
 *
 * Gates every checkout trigger inside its parent cart <form> behind a required
 * "I agree to the Terms & Conditions" checkbox. A free, in-theme replacement for
 * a paid checkout-agreement app. Rendered by snippets/terms-agreement.liquid in
 * both the cart page and the cart drawer.
 *
 * Defined here (a plain deferred asset) rather than inline in the snippet so the
 * element is registered exactly once per page and survives AJAX cart re-renders,
 * where injected <script> tags would not execute.
 */
(function () {
  if (window.customElements && customElements.get('terms-agreement')) return;

  customElements.define(
    'terms-agreement',
    class extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('[data-terms-checkbox]');
        this.error = this.querySelector('[data-terms-error]');
        this.tsInput = this.querySelector('[data-terms-timestamp]');
        this.form = this.closest('form');
        if (!this.checkbox || !this.form) return;

        this._onChange = this.update.bind(this);
        this._onSubmit = this.handleSubmit.bind(this);
        this.checkbox.addEventListener('change', this._onChange);
        this.form.addEventListener('submit', this._onSubmit, true);

        this.update();
      }

      disconnectedCallback() {
        if (this.checkbox) this.checkbox.removeEventListener('change', this._onChange);
        if (this.form) this.form.removeEventListener('submit', this._onSubmit, true);
      }

      update() {
        var agreed = this.checkbox.checked;

        // Standard checkout submit button(s)
        this.form.querySelectorAll('[name="checkout"]').forEach(function (btn) {
          btn.disabled = !agreed;
          btn.setAttribute('aria-disabled', String(!agreed));
        });

        // Accelerated / dynamic checkout buttons (Shop Pay, PayPal, Apple Pay, etc.)
        this.form.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
          el.style.opacity = agreed ? '' : '0.4';
          el.style.pointerEvents = agreed ? '' : 'none';
          el.setAttribute('aria-disabled', String(!agreed));
        });

        // Record "Terms Accepted At" on the order once the box is ticked.
        // Same field name + human-readable local format the old R Terms app used.
        if (this.tsInput) {
          this.tsInput.disabled = !agreed;
          if (agreed && !this.tsInput.value) this.tsInput.value = new Date().toString();
        }

        if (agreed && this.error) this.error.hidden = true;
      }

      handleSubmit(event) {
        var submitter = event.submitter;
        var isCheckout = submitter && submitter.getAttribute && submitter.getAttribute('name') === 'checkout';
        if (!isCheckout) return; // let cart updates / recalculations through

        if (!this.checkbox.checked) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (this.error) this.error.hidden = false;
          this.checkbox.focus();
        }
      }
    }
  );
})();
